import { render } from "./Homepage.vue?vue&type=template&id=3de74c78&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=3de74c78&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3de74c78"

export default script